// extracted by mini-css-extract-plugin
module.exports = {"container":"container___0ii7d","content":"content___vTv5O","top":"top___ouYl9","header":"header___y6TjT","logo":"logo___4mEfM","title":"title___p88wM","desc":"desc___ZjOOw"};